import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';


const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden px-4 sm:px-6" data-testid="hero-section">
      <div className="space-background"></div>
      
      <div className="floating-orb w-64 h-64 sm:w-96 sm:h-96 bg-[#00E5FF] top-10 sm:top-20 left-5 sm:left-10"></div>
      <div className="floating-orb w-56 h-56 sm:w-80 sm:h-80 bg-[#1F3C88] bottom-10 sm:bottom-20 right-5 sm:right-10" style={{animationDelay: '2s'}}></div>
      
      <div className="relative z-10 max-w-5xl mx-auto text-center" data-aos="fade-up">
        
        
        <div className="inline-flex items-center space-x-2 px-3 sm:px-4 py-2 rounded-full bg-white/5 backdrop-blur-sm border border-white/10 mb-6 sm:mb-8">
          <Sparkles className="w-3 h-3 sm:w-4 sm:h-4 text-[#00E5FF]" />
          <span className="text-xs sm:text-sm">Innovation Through Technology</span>
        </div>
        
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6 gradient-text leading-tight px-4" data-testid="hero-headline">
          Engineering Digital Gravity.
        </h1>
        
        <p className="text-sm sm:text-base md:text-lg text-gray-300 max-w-3xl mx-auto mb-8 sm:mb-12 px-4" data-testid="hero-subheadline">
          We build powerful, scalable, and future-ready digital solutions that move your business forward.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 px-4">
          <button 
            onClick={() => scrollToSection('services')} 
            className="w-full sm:w-auto glow-button flex items-center justify-center space-x-2 text-sm sm:text-base"
            data-testid="hero-explore-button"
          >
            <span>Explore Services</span>
            <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" />
          </button>
          <button 
            onClick={() => scrollToSection('contact')} 
            className="w-full sm:w-auto px-6 sm:px-8 py-3 rounded-full border border-[#00E5FF]/50 hover:bg-[#00E5FF]/10 transition-all hover:scale-105 text-sm sm:text-base"
            data-testid="hero-contact-button"
          >
            Contact Us
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
